"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _commonReact = require("@devsta/common-react");

var _ShotTab = _interopRequireDefault(require("../components/ShotTab"));

function ShotTab(_ref) {
  var assetIds = _ref.assetIds,
      updateAssets = _ref.updateAssets,
      organisationId = _ref.organisationId,
      hasUpdatePermission = _ref.hasUpdatePermission;
  return _react.default.createElement(_commonReact.UploaderConsumer, null, function (_ref2) {
    var addFileToQueue = _ref2.addFileToQueue;
    return _react.default.createElement(_ShotTab.default, {
      addFileToQueue: addFileToQueue,
      assetIds: assetIds || [],
      updateAssets: updateAssets,
      organisationId: organisationId,
      hasUpdatePermission: hasUpdatePermission
    });
  });
}

var _default = ShotTab;
exports.default = _default;